export const SOFTLINE_API_WORKFLOW = '/v1/workflow/entities';
export const SOFTLINE_API_WORKFLOW_DATA = '/v1/workflow/data';
export const SOFTLINE_API_WORKFLOW_NEXT =
  '/v1/workflow/entities/{{id}}/next/{{task}}';
